// real
import "jspdf-autotable";
import { useEffect, useRef, useState } from "react";
import { AxiosInstance } from "../../../axios";
import { CSVLink } from "react-csv";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import React from "react";
import jsPDF from "jspdf";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { R_PER_PAGE } from "../../../labels";
import DatePickerSample from "../DatePicker";
import { TailSpin } from "react-loader-spinner";
import { ExportTableToPdf } from "../../ReusuableComponent/ExportTableToPdf";
import toast from "react-hot-toast";

function Listview() {
  const menuList = JSON.parse(sessionStorage.getItem("menu_list")) || [];
  const userJSON = sessionStorage.getItem("userDetails");
  let userType = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userType = user?.user_type;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const moment = require("moment-timezone");
  let page = R_PER_PAGE;
  const location = useLocation();
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  const { typeFilter } = useParams();
  const txtBSearch = useRef(null); //search icon
  const {
    filStatus,
    filCateCode,
    fillPayType,
    fillSec,
    fillBatch,
    fillLoc,
    fillAon,
    fillType,
    fillSearch,
    fillTypeUrl,
  } = location.state ? location.state : {};

  // use state
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [updateListData, setUpdateListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [csvListData, setCsvListData] = useState([]);
  const [isOpen, setIsOpen] = useState({
    status: false,
    appliedOn: false,
    type: false,
    section: false,
    category_code: false,
    payment_type: false,
    course_name: false,
    batch_name: false,
    location_name: false,
  });
  const [appData, setAppData] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const [section, setSection] = useState([]);
  const [category_code, setCategory_code] = useState([]);
  const [dCourse, setDcourse] = useState([]);
  const [dCourses, setDcourses] = useState([]);
  const [dLocation, setDLocation] = useState([]);
  const [dSection, setDSection] = useState([]);
  const [dSections, setDSections] = useState([]);
  const [course_name, setCourse_name] = useState([]);
  const [batch_name, setBatch_name] = useState([]);
  const [location_name, setLocation_name] = useState([]);
  const [payment_type, setPayment_type] = useState([]);
  const [updateChipData, setUpdateChipData] = useState([]);
  const [status, setStatus] = useState([]);
  const [appOn, setAppOn] = useState([]);
  const [typeOn, setTypeOn] = useState([]);

  let start = (currentPage - 1) * rowsPerPage;
  let end = start + rowsPerPage;
  let currentData = updateListData.slice(start, end);
  // total table data  with pages
  let totalPages = Math.ceil(updateListData.length / rowsPerPage);

  let filterStatus = [];
  let filterType = [];
  let filterApplyed = [];
  let filterSearch = [];
  let filtersection = [];
  let filterCateCode = [];
  let filterPayType = [];
  let filterCouName = [];
  let filterBatchName = [];
  let filterLName = [];

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    filtersection = section;
  }, [section]);

  useEffect(() => {
    filterStatus = status;
  }, [status]);

  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);
  useEffect(() => {
    filterCateCode = category_code;
  }, [category_code]);
  useEffect(() => {
    filterPayType = payment_type;
  }, [payment_type]);
  useEffect(() => {
    filterCouName = course_name;
  }, [course_name]);

  useEffect(() => {
    filterBatchName = batch_name;
  }, [batch_name]);

  useEffect(() => {
    filterLName = location_name;
  }, [location_name]);

  useEffect(() => {
    filterApplyed = appOn;
  }, [appData]);

  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    if (filStatus && filStatus.length > 0) {
      setStatus(filStatus);
      filterStatus = filStatus;
    } else {
      setStatus([{ id: "0", name: "WaitingForApproval", type: "status" }]);
      filterStatus = [{ id: "0", name: "WaitingForApproval", type: "status" }];
    }
    if (filCateCode && filCateCode.length > 0) {
      setCategory_code(filCateCode);
      filterCateCode = filCateCode;
    }
    if (fillPayType && fillPayType.length > 0) {
      setPayment_type(fillPayType);
      filterPayType = fillPayType;
    }
    if (fillSec && fillSec.length > 0) {
      setSection(fillSec);
      filtersection = fillSec;
    }
    if (fillBatch && fillBatch.length > 0) {
      setBatch_name(fillBatch);
      filterBatchName = fillBatch;
    }
    if (fillLoc && fillLoc.length > 0) {
      setLocation_name(fillLoc);
      filterLName = fillLoc;
    }
    if (fillSearch && fillSearch.length > 0) {
      filterSearch = [{ name: "" + fillSearch, type: "search" }];
      setSearchTerm(fillSearch);
    } else {
      if (searchTerm) {
        setSearchTerm(searchTerm);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    if (fillAon && fillAon.length > 0) {
      setAppOn(fillAon);
      filterApplyed = fillAon;
    } else {
      setAppOn(appOn);
      filterApplyed = appOn;
    }
    if (fillType && fillType.length > 0) {
      setTypeOn(fillType);
      filterType = fillType;
    } else if (typeFilter === undefined || typeFilter === null) {
      setTypeOn([]);
      filterType = [];
    } else if (typeFilter === "0" && !fillType) {
      setTypeOn([{ id: "0", name: "course", type: "type" }]);
      filterType = [{ id: "0", name: "course", type: "type" }];
    } else if (typeFilter === "1" && !fillType) {
      setTypeOn([{ id: "1", name: "TestBatch", type: "type" }]);
      filterType = [{ id: "1", name: "TestBatch", type: "type" }];
    } else if (typeFilter === "3" && !fillType) {
      setTypeOn([{ id: "3", name: "SpecialClass", type: "type" }]);
      filterType = [{ id: "3", name: "SpecialClass", type: "type" }];
    } else if (typeFilter === "2" && !fillType) {
      setTypeOn([{ id: "2", name: "Counselling", type: "type" }]);
      filterType = [{ id: "2", name: "Counselling", type: "type" }];
    } else if (typeFilter === "4" && !fillType) {
      setTypeOn([{ id: "4", name: "ModelExam", type: "type" }]);
      filterType = [{ id: "4", name: "ModelExam", type: "type" }];
    } else if (typeFilter === "5" && !fillType) {
      setTypeOn([{ id: "5", name: "MockInterview", type: "type" }]);
      filterType = [{ id: "5", name: "MockInterview", type: "type" }];
    } else {
      setTypeOn(typeOn);
      filterType = typeOn;
    }
    loadChipdata();
  }, [typeFilter]);

  useEffect(() => {
    if (updateChipData.length > 0) {
      loadListdata();
    }
    // else {
    // loadListdata();
    // }
  }, [updateChipData]);

  function updateStateData() {
    filterStatus = status;
    filterType = typeOn;
    filtersection = section;
    filterCateCode = category_code;
    filterPayType = payment_type;
    filterBatchName = batch_name;
    filterLName = location_name;
    filterCouName = course_name;
    filterApplyed = appOn;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  //sorting function

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  const handleFilterCourseSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = dCourse.filter(
        (item) => item && item.toLowerCase().includes(searchInput.toLowerCase())
      );
      // Do something with the matchingObjects, such as updating state or displaying them in the UI
      setDcourses(matchingObjects);
    } else {
      setDcourses(dCourse);
    }
  };

  const handleFilterSectionSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = dSection.filter(
        (item) => item && item.toLowerCase().includes(searchInput.toLowerCase())
      );

      // Do something with the matchingObjects, such as updating state or displaying them in the UI
      setDSection(matchingObjects);
    } else {
      setDSection(dSections);
    }
  };

  // filter checkbox update
  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    if (
      name === "waitingForApproval" ||
      name === "Rejected" ||
      name === "approved" ||
      name === "onHold"
    ) {
      if (checked) {
        setStatus([...status, { id: value, name: name, type: "status" }]);
      } else {
        setStatus(status.filter((item) => item.id !== value));
      }
    } else if (
      name === "course" ||
      name === "TestBatch" ||
      name === "SpecialClass" ||
      name === "Counselling" ||
      name === "MockInterview" ||
      name === "ModelExam"
    ) {
      if (checked) {
        setTypeOn([...typeOn, { id: value, name: name, type: "type" }]);
      } else {
        setTypeOn(typeOn.filter((item) => item.id !== value));
      }
    } else if (typename === "category_code") {
      if (checked) {
        setCategory_code([
          ...category_code,
          { name: value, type: "category_code" },
        ]);
      } else {
        setCategory_code(category_code.filter((item) => item.name !== value));
      }
    } else if (names === "Offline" || names === "Online") {
      if (checked) {
        setPayment_type([{ id: value, name: name, type: "payment_type" }]);
      } else {
        setPayment_type(payment_type.filter((item) => item.id !== value));
      }
    } else if (names === "course_name") {
      if (checked) {
        setCourse_name([...course_name, { name: value, type: "course_name" }]);
      } else {
        setCourse_name(course_name.filter((item) => item.name !== value));
      }
    } else if (names === "batch_name") {
      if (checked) {
        setBatch_name([
          ...batch_name,
          { id: value, name: name, type: "batch_name" },
        ]);
      } else {
        setBatch_name(batch_name.filter((item) => item.id !== value));
      }
    } else if (names === "section") {
      if (checked) {
        setSection([...section, { id: value, name: name, type: "section" }]);
      } else {
        setSection(section.filter((item) => item.id !== value));
      }
    } else if (names === "location_name") {
      if (checked) {
        setLocation_name([
          ...location_name,
          { id: value, name: name, type: "location_name" },
        ]);
      } else {
        setLocation_name(location_name.filter((item) => item.id !== value));
      }
    }
  };

  // handle search function
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };
  // -------Search Icon function--
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        code: "Enter",
        keyCode: 13,
        which: 13,
        bubbles: true,
      });
      txtBSearch.current.dispatchEvent(event);
    }
  };
  //-----end--
  // handle edit function
  const handleEdit = (userId, adm_pk, appliedOn, type) => {
    const admissId = adm_pk;
    navigate(`/studentConfirm/${userId}/${admissId}/${appliedOn}/${type}`, {
      state: {
        FSF: status,
        FCAF: category_code,
        FPYM: payment_type,
        FSEC: section,
        FBTN: batch_name,
        FLOC: location_name,
        FAPON: appOn,
        FTF: typeOn,
        FSEAR: searchTerm,
        FTYPE: typeFilter ? typeFilter : "",
      },
    });
  };

  const handleChangeDate = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");

    if (name === "FDate" || name === "TDate") {
      // First, update the date fields and reset Days
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "", // Reset Days when FDate or TDate is set
        };

        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;

        // Only set AppOn if both from and to dates are available
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const handleAppliedOn = (e) => {
    const { name, value, checked } = e.target;

    if (name === "FDate" || name === "TDate") {
      setAppData((prevState) => {
        const updated = {
          ...prevState,
          [name]: value,
          Days: "", // Reset Days when FDate or TDate is changed
        };

        const from = name === "FDate" ? value : updated.FDate;
        const to = name === "TDate" ? value : updated.TDate;

        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOn([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        } else {
          setAppOn([
            {
              name: "",
              fdate: "",
              edate: "",
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    } else if (name === "Days") {
      if (checked) {
        // Set Days and reset FDate/TDate
        setAppData({
          FDate: "",
          TDate: "",
          Days: value,
        });

        const today = new Date();
        let fdate = "";
        let edate = "";
        let label = "";

        if (value === "Today") {
          fdate = edate = moment(today).format("YYYY-MM-DD");
          label = "Today";
        } else if (value === "Yesterday") {
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fdate = edate = moment(yesterday).format("YYYY-MM-DD");
          label = "Yesterday";
        } else if (value === "Tweek") {
          const start = moment(today).startOf("week").toDate();
          const end = moment(today).endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This week";
        } else if (value === "Lweek") {
          const start = moment(today)
            .subtract(1, "week")
            .startOf("week")
            .toDate();
          const end = moment(today).subtract(1, "week").endOf("week").toDate();
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last week";
        } else if (value === "Tmonth") {
          const start = new Date(today.getFullYear(), today.getMonth(), 1);
          const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "This month";
        } else if (value === "Lmonth") {
          const start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const end = new Date(today.getFullYear(), today.getMonth(), 0);
          fdate = moment(start).format("YYYY-MM-DD");
          edate = moment(end).format("YYYY-MM-DD");
          label = "Last month";
        }

        setAppOn([
          {
            name: label,
            fdate,
            edate,
            type: "dayRange",
            Days: value,
          },
        ]);
      }
    }
  };

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
    // setUpdatePag(true);
    // setUpdatePagDis(false);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
    // setUpdatePag(false);
    // setUpdatePagDis(true);
  };
  // page count handle
  const handlePageCount = (e) => {
    const { name, value, checked } = e.target;
    if (name === "pageCount") {
      setRowsPerPage(parseInt(value));
      setCurrentPage(1);
      // setUpdateListData([]);
    }
    // loadListdata();
  };

  //  filter box open function
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);
  const handleFilter = (e, filname) => {
    if (filname === "status") {
      setIsOpen((prevState) => ({
        appliedOn: false,
        type: false,
        payment_type: false,
        section: false,
        course_name: false,
        location_name: false,
        category_code: false,
        batch_name: false,
        status: !prevState.status,
      }));
    } else if (filname === "appliedOn") {
      setIsOpen((prevState) => ({
        type: false,
        section: false,
        status: false,
        payment_type: false,
        category_code: false,
        location_name: false,
        course_name: false,
        batch_name: false,
        appliedOn: !prevState.appliedOn,
      }));
    } else if (filname === "type") {
      setIsOpen((prevState) => ({
        section: false,
        status: false,
        payment_type: false,
        appliedOn: false,
        category_code: false,
        location_name: false,
        course_name: false,
        batch_name: false,
        type: !prevState.type,
      }));
    } else if (filname === "batch_name") {
      setIsOpen((prevState) => ({
        section: false,
        status: false,
        payment_type: false,
        appliedOn: false,
        location_name: false,
        type: false,
        category_code: false,
        course_name: false,
        batch_name: !prevState.batch_name,
      }));
    } else if (filname === "section") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        batch_name: false,
        payment_type: false,
        location_name: false,
        category_code: false,
        course_name: false,
        section: !prevState.section,
      }));
    } else if (filname === "category_code") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        location_name: false,
        batch_name: false,
        section: false,
        payment_type: false,
        course_name: false,
        category_code: !prevState.category_code,
      }));
    } else if (filname === "payment_type") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        location_name: false,
        batch_name: false,
        category_code: false,
        section: false,
        course_name: false,
        payment_type: !prevState.payment_type,
      }));
    } else if (filname === "course_name") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        batch_name: false,
        category_code: false,
        location_name: false,
        section: false,
        payment_type: false,
        course_name: !prevState.course_name,
      }));
    } else if (filname === "batch_name") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        course_name: false,
        category_code: false,
        location_name: false,
        section: false,
        payment_type: false,
        batch_name: !prevState.batch_name,
      }));
    } else if (filname === "location_name") {
      setIsOpen((prevState) => ({
        status: false,
        appliedOn: false,
        type: false,
        batch_name: false,
        category_code: false,
        course_name: false,
        section: false,
        payment_type: false,
        location_name: !prevState.location_name,
      }));
    }
  };

  //chip list style

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setSearchTerm("");
    setStatus([]);
    setSection([]);
    setCategory_code([]);
    setPayment_type([]);
    setCourse_name([]);
    setBatch_name([]);
    setLocation_name([]);
    setUpdateChipData([{ id: 0, name: "ClearFilter", type: "ClearFilter" }]);
    setAppOn([]);
    setTypeOn([]);
    setAppData({
      FDate: "",
      TDate: "",
      Days: "",
    });
    filterStatus = [];
    filterType = [];
    filterApplyed = [];
    filterSearch = [];
    filtersection = [];
    filterCateCode = [];
    filterPayType = [];
    filterCouName = [];
    filterBatchName = [];
    filterLName = [];

    // Reset location state by navigating to the same route without state
    navigate(location.pathname, { replace: true, state: null });
  };

  // filter apply button

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        status: false,
      });
    } else if (name === "appliedOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        type: false,
      });
    } else if (name === "section") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "category_code") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category_code: false,
      });
    } else if (name === "payment_type") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        payment_type: false,
      });
    } else if (name === "course_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        course_name: false,
      });
    } else if (name === "batch_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "location_name") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        location_name: false,
      });
    }
  };

  function loadListdata() {
    setIsLoading(true);
    let tempstatus = [];
    let temptypeon = [];
    let tempstatusnum = [];
    let tempTypenum = [];
    let tempsection = [];
    let tempCateCode = [];
    let tempPayTypenum = [];
    let tempLocationNum = [];
    let tempCouName = [];
    let tempBatchName = [];
    let tempLocationName = [];
    let tempPayType = [];

    status.map((obj) => {
      tempstatus.push(obj.id);
    });
    section.map((obj) => {
      tempsection.push(obj.name);
    });
    typeOn.map((obj) => {
      temptypeon.push(obj.id);
    });
    category_code.map((obj) => {
      tempCateCode.push(obj.name);
    });
    payment_type.map((obj) => {
      tempPayType.push(obj.id);
    });
    course_name.map((obj) => {
      tempCouName.push(obj.name);
    });

    batch_name.map((obj) => {
      tempBatchName.push(obj.name);
    });

    location_name.map((obj) => {
      tempLocationName.push(obj.id);
    });

    tempTypenum = temptypeon.map(Number);
    tempPayTypenum = tempPayType.map(Number);
    tempLocationNum = tempLocationName.map(Number);
    tempstatusnum = [...new Set(tempstatus)].map(Number);

    let statusFilter = {
      type: typeOn.length > 0 ? tempTypenum : "",
      location: location_name.length > 0 ? tempLocationNum : "",
      course_name: course_name.length > 0 ? tempCouName : "",
      mode_of_payment:
        payment_type.length > 0
          ? tempPayTypenum.length === 1
            ? tempPayTypenum[0]
            : ""
          : "",
      payment_type: 1, // 1 - online , 0 - offline
      category: category_code.length > 0 ? tempCateCode : "",
      section: section.length > 0 ? tempsection : "",
      status: status.length > 0 ? tempstatusnum : "",
      start_date:
        appOn.length > 0
          ? appOn[0].edate !== ""
            ? appOn[0].fdate + " 00:00:00"
            : appOn[0].fdate
          : "",
      end_date:
        appOn.length > 0
          ? appOn[0].edate !== ""
            ? appOn[0].edate + " 23:59:00"
            : appOn[0].edate
          : "",
      search: searchTerm.length > 0 ? searchTerm : "",
      batch_name: batch_name.length > 0 ? tempBatchName : "",
      page_size: "",
      page_no: "",
      // page_size: rowsPerPage,
      // page_no: currentPage,
    };

    AxiosInstance.post("api/course/admission/list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            fullname: item.fullname,
            admission_id: item.admission_id,
            phone_no: item.phone_no,
            mode_of_payment: item.mode_of_payment === 1 ? "Online" : "Offline",
            category_code: item.category_code,
            course_name: item.course_name,
            section: item.section,
            type:
              item.type === 4
                ? "Model exam "
                : item.type === 0
                ? "Course"
                : item.type === 1
                ? "Test Batch"
                : item.type === 3
                ? " Special class"
                : item.type === 2
                ? "Counselling"
                : item.type === 5
                ? "Mock Interview"
                : "None",
            batch_name: item.batch_name,
            location_name: item.location_name,
            paid_amount: item.paid_amount,
            balance_amt: item.balance_amt,
            appliedOn: moment(item.appliedOn).format("YYYY/MM/DD"),
            status:
              item.status === 0
                ? "Waiting for Approval"
                : item.status === 1
                ? "Approved"
                : item.status === 2
                ? "OnHold"
                : "Rejected",
          }));
          // Set CSV data
          setCsvListData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
          const batch_nameList = fiata
            .map((item) => (item.batch_name !== null ? item.batch_name : []))
            .flat();
          // Remove duplicates by converting the array to a Set and back to an array
          const uniqueBatchNameList = [...new Set(batch_nameList)];
          setDcourse(uniqueBatchNameList);
          setDcourses(uniqueBatchNameList);
          const locationList = fiata
            .map((item) =>
              item.location_name !== null
                ? { name: item.location_name, id: item.location_id }
                : null
            )
            .flat();
          // Remove duplicates by converting the array to a Set and back to an array
          const uniqueLocationList = [
            ...new Map(locationList.map((item) => [item.id, item])).values(),
          ];
          setDLocation(uniqueLocationList);
          const SectionList = fiata
            .map((item) => (item.section !== null ? item.section : []))
            .flat();
          // Remove duplicates by converting the array to a Set and back to an array
          const UniqueSection = [...new Set(SectionList)];
          setDSection(UniqueSection);
          setDSections(UniqueSection);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setUpdateListData([]);
        return error;
      });
  }

  function loadChipdata() {
    let tempArr = [];

    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterType.map((obj) => {
      tempArr.push(obj);
    });
    filtersection.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyed.map((obj) => {
      tempArr.push(obj);
    });
    filterCateCode.map((obj) => {
      tempArr.push(obj);
    });
    filterPayType.map((obj) => {
      tempArr.push(obj);
    });
    filterCouName.map((obj) => {
      tempArr.push(obj);
    });

    filterBatchName.map((obj) => {
      tempArr.push(obj);
    });
    filterLName.map((obj) => {
      tempArr.push(obj);
    });
    if (tempArr.length > 0) {
      setUpdateChipData(tempArr);
    } else {
      setUpdateChipData([{ id: 0, name: "ClearFilter", type: "ClearFilter" }]);
    }
  }

  // filter clear button
  const handleClear = (name) => {
    updateStateData();
    if (name === "appliedOn") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
      setIsOpen({
        ...isOpen,
        appliedOn: false,
      });
    } else if (name === "status") {
      // Clear the status array
      setStatus([]);
      filterStatus = [];
      setIsOpen({
        ...isOpen,
        status: false,
      });
      // setUpdateListData(listData);
    } else if (name === "type") {
      setTypeOn([]);
      filterType = [];

      setIsOpen({
        ...isOpen,
        type: false,
      });
    } else if (name === "section") {
      setSection([]);
      filtersection = [];

      setIsOpen({
        ...isOpen,
        section: false,
      });
    } else if (name === "category_code") {
      setCategory_code([]);
      filterCateCode = [];

      setIsOpen({
        ...isOpen,
        category_code: false,
      });
    } else if (name === "payment_type") {
      setPayment_type([]);
      filterPayType = [];

      setIsOpen({
        ...isOpen,
        payment_type: false,
      });
    } else if (name === "course_name") {
      setCourse_name([]);
      filterCouName = [];

      setIsOpen({
        ...isOpen,
        course_name: false,
      });
    } else if (name === "batch_name") {
      setBatch_name([]);
      filterBatchName = [];

      setIsOpen({
        ...isOpen,
        batch_name: false,
      });
    } else if (name === "location_name") {
      setLocation_name([]);
      filterLName = [];

      setIsOpen({
        ...isOpen,
        location_name: false,
      });
    }
    loadChipdata();
  };

  //   checking once again  -  handle delete function
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "status") {
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = status.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "type") {
      setTypeOn(typeOn.filter((item) => item.id !== chipToDelete.id));
      filterType = typeOn.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "category_code") {
      setCategory_code(
        category_code.filter((item) => item.id !== chipToDelete.id)
      );
      filterCateCode = category_code.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "payment_type") {
      setPayment_type(
        payment_type.filter((item) => item.id !== chipToDelete.id)
      );
      filterPayType = payment_type.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "course_name") {
      setCourse_name(course_name.filter((item) => item.id !== chipToDelete.id));
      filterCouName = course_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "batch_name") {
      setBatch_name(batch_name.filter((item) => item.id !== chipToDelete.id));
      filterBatchName = batch_name.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "location_name") {
      setLocation_name(
        location_name.filter((item) => item.id !== chipToDelete.id)
      );
      filterLName = location_name.filter((item) => item.id !== chipToDelete.id);
    } else if (chipToDelete.type === "dayRange") {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    } else if (chipToDelete.type === "section") {
      setSection(section.filter((item) => item.id !== chipToDelete.id));
      filtersection = section.filter((item) => item.id !== chipToDelete.id);
    } else {
      setAppData({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOn([]);
      filterApplyed = [];
    }
    loadChipdata();
  };

  const filterPamentRef = useRef(null);
  const filterCategoryRef = useRef(null);
  const filterSectionRef = useRef(null);
  const filterTypeRef = useRef(null);
  const filterBatchRef = useRef(null);
  const filterLocationRef = useRef(null);
  const filterAppliedRef = useRef(null);
  const filterStatusRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // PAYMENT TYPE FILTER
      if (
        filterPamentRef.current &&
        !filterPamentRef.current.contains(event.target)
      ) {
        const hasPaymentType = updateChipData.some(
          (chipItem) => chipItem.type === "eventName"
        );

        if (hasPaymentType) {
          const updatedPaymentType = updateChipData.filter(
            (chipItem) => chipItem.type === "eventName"
          );
          setPayment_type(updatedPaymentType);
        } else {
          setPayment_type([]);
        }

        setIsOpen((prev) => ({ ...prev, payment_type: false }));
      }

      //CATEGORY FILTER
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "category_code"
        );

        if (hasCategory) {
          const updatedCategory = updateChipData.filter(
            (chipItem) => chipItem.type === "category_code"
          );
          setCategory_code(updatedCategory);
        } else {
          setCategory_code([]);
        }

        setIsOpen((prev) => ({ ...prev, category_code: false }));
      }

      //SECTION FILTER
      if (
        filterSectionRef.current &&
        !filterSectionRef.current.contains(event.target)
      ) {
        const hasSection = updateChipData.some(
          (chipItem) => chipItem.type === "section"
        );

        if (hasSection) {
          const updatedSection = updateChipData.filter(
            (chipItem) => chipItem.type === "section"
          );
          setSection(updatedSection);
        } else {
          setSection([]);
        }

        setIsOpen((prev) => ({ ...prev, section: false }));
      }

      //TYPE FILTER
      if (
        filterTypeRef.current &&
        !filterTypeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "type"
        );

        if (hasType) {
          const updatedType = updateChipData.filter(
            (chipItem) => chipItem.type === "type"
          );
          setTypeOn(updatedType);
        } else {
          setTypeOn([]);
        }

        setIsOpen((prev) => ({ ...prev, type: false }));
      }

      //BATCH FILTER
      if (
        filterBatchRef.current &&
        !filterBatchRef.current.contains(event.target)
      ) {
        const hasBatch = updateChipData.some(
          (chipItem) => chipItem.type === "batch_name"
        );

        if (hasBatch) {
          const updatedBatch = updateChipData.filter(
            (chipItem) => chipItem.type === "batch_name"
          );
          setBatch_name(updatedBatch);
        } else {
          setBatch_name([]);
        }

        setIsOpen((prev) => ({ ...prev, batch_name: false }));
      }

      //LOCATION FILTER
      if (
        filterLocationRef.current &&
        !filterLocationRef.current.contains(event.target)
      ) {
        const hasLocation = updateChipData.some(
          (chipItem) => chipItem.type === "location_name"
        );

        if (hasLocation) {
          const updatedLocation = updateChipData.filter(
            (chipItem) => chipItem.type === "location_name"
          );
          setLocation_name(updatedLocation);
        } else {
          setLocation_name([]);
        }

        setIsOpen((prev) => ({ ...prev, location_name: false }));
      }

      // APPLIED ON FILTER
      if (
        filterAppliedRef.current &&
        !filterAppliedRef.current.contains(event.target)
      ) {
        const mismatchedDay = updateChipData.find(
          (chipItem) => chipItem.Days && chipItem.Days === appData.Days
        );

        if (mismatchedDay) {
          setAppData({
            FDate: "",
            TDate: "",
            Days: mismatchedDay.Days,
          });
          setAppOn([
            {
              FDate: "",
              TDate: "",
              Days: mismatchedDay.Days,
            },
          ]);
        } else {
          const mismatchedDate = updateChipData.find(
            (chipItem) =>
              chipItem.fdate === appData.FDate &&
              chipItem.edate === appData.TDate
          );

          if (mismatchedDate) {
            setAppData({
              FDate: mismatchedDate.fdate,
              TDate: mismatchedDate.edate,
              Days: "",
            });
            setAppOn([
              {
                FDate: mismatchedDate.fdate,
                TDate: mismatchedDate.edate,
                Days: "",
              },
            ]);
          } else {
            setAppData({
              FDate: "",
              TDate: "",
              Days: "",
            });
            setAppOn([]);
          }
        }

        setIsOpen((prev) => ({ ...prev, appliedOn: false }));
      }

      // STATUS FILTER
      if (
        filterStatusRef.current &&
        !filterStatusRef.current.contains(event.target)
      ) {
        const hasStatus = updateChipData.some(
          (chipItem) => chipItem.type === "status"
        );

        if (hasStatus) {
          const updatedStatus = updateChipData.filter(
            (chipItem) => chipItem.type === "status"
          );
          setStatus(updatedStatus);
        } else {
          setStatus([]);
        }

        setIsOpen((prev) => ({ ...prev, status: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, appData]);

  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Name",
      // "AdmissionId",
      "Phone Number",
      "Mode of Payment",
      // "Category",
      // "Course",
      // "Section",
      // "Type",
      "Batch Name",
      // "Location",
      "Paid Amount",
      // "Balance Amount",
      "Applied On",
      // "Status",
    ];

    const rows = updateListData.map((item, index) => [
      // index + 1,
      item.fullname ?? "-",
      // item.admission_id ?? "-",
      item.phone_no ?? "-",
      item.mode_of_payment === 1 ? "Online" : "Offline",
      // item.category_code ?? "-",
      // item.course_name ?? "-",
      // item.section ?? "-",
      // item.type === 4
      //   ? "Model Exam"
      //   : item.type === 0
      //   ? "Course"
      //   : item.type === 1
      //   ? "Test Batch"
      //   : item.type === 3
      //   ? "Special Class"
      //   : item.type === 2
      //   ? "Counselling"
      //   : item.type === 5
      //   ? "Mock Interview"
      //   : "None",
      item.batch_name ?? "-",
      // item.location_name ?? "-",
      item.paid_amount ?? "-",
      // item.balance_amt ?? "-",
      item.appliedOn && moment(item.appliedOn).isValid()
        ? moment(item.appliedOn).format("YYYY/MM/DD")
        : "-",
      // item.status === 0
      //   ? "Waiting for Approval"
      //   : item.status === 1
      //   ? "Approved"
      //   : item.status === 2
      //   ? "OnHold"
      //   : "Rejected",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Admission List Data",
          headers,
          rows,
          filename: "AdmissionList.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Name", key: "fullname" },
    { label: "Admission ID", key: "admission_id" },
    { label: "Phone Number", key: "phone_no" },
    { label: "Mode of Payment", key: "mode_of_payment" },
    { label: "Category", key: "category_code" },
    { label: "Course", key: "course_name" },
    { label: "Section", key: "section" },
    { label: "Type", key: "type" },
    { label: "Batch", key: "batch_name" },
    { label: "Location", key: "location_name" },
    { label: "Paid Amount", key: "paid_amount" },
    { label: "Balance Amount", key: "balance_amt" },
    { label: "Applied On", key: "appliedOn" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && (
        <TailSpin
          visible={true}
          height="100"
          width="90"
          color="#4fa94d"
          ariaLabel="tail-spin-loading"
          radius="1"
          wrapperStyle={{}}
          wrapperClass="custom-spinner"
        />
      )}
    </div>
  ) : (
    <div className=" ListViewForm ">
      <h4 className="Title">Admission Form</h4>
      <div className="row">
        <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="input-group ">
            <input
              ref={txtBSearch}
              type="text"
              class="Inputs"
              id="SearchInput"
              name="SearchInput"
              placeholder="Search by Name,ID,Phone Number and Course"
              onKeyDown={handleSearch}
            />
            <span
              class="input-group-text"
              id="SearchInput"
              onClick={handleSearchFocus}
            >
              <span className="material-icons" onClick={handleSearchFocus}>
                search
              </span>
            </span>
          </div>
        </div>
        <div className="col-lg-3 col-md-1 col-sm-12 col-xs-12"></div>
        <div className="col-lg-5 dflex col-md-7">
          {((Array.isArray(menuList) && menuList.includes(74)) ||
            userType === 1) && (
            <>
              <button type="button" className="SaveButton me-3">
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                <CSVLink
                  data={csvListData}
                  headers={csvHeaders}
                  filename={"AdmissionList.csv"}
                >
                  Download as CSV
                </CSVLink>
              </button>
              <button
                type="button"
                className="SaveButton"
                onClick={generatePDF}
              >
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                <a> Download as PDF</a>
              </button>
            </>
          )}
        </div>
      </div>
      {/* chip items */}
      {updateChipData.filter((io) => io.name !== "ClearFilter").length > 0 ? (
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-xs-12 " id="paperil">
            <Paper
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {updateChipData
                .filter((io) => io.name !== "ClearFilter")
                .map((data, index) => {
                  let key = "";
                  if (data.name === "WaitingForApproval") {
                    key = "" + "Waiting For Approval";
                  } else if (data.name === "course") {
                    key = "" + "Course";
                  } else if (data.name === "approved") {
                    key = "" + "Approved";
                  } else if (data.name === "onHold") {
                    key = "" + "OnHold";
                  } else if (data.name === "ModelExam") {
                    key = "" + "Model Exam";
                  } else if (data.name === "MockInterview") {
                    key = "" + "Mock Interview";
                  } else if (data.name === "SpecialClass") {
                    key = "" + "Special Class";
                  } else if (data.name === "TestBatch") {
                    key = "" + "Test Batch";
                  } else {
                    key = "" + data.name;
                  }
                  let icon;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

              <ListItem>
                <a
                  className="allclear"
                  href="javascript:void(0)"
                  onClick={handleAllClear}
                >
                  Clear All Filters
                </a>
              </ListItem>
            </Paper>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className="row m-0 mt-2">
        <div className="col-md-12 table-responsive tableMinHeight px-0">
          <table className="table" id="example">
            {" "}
            <thead>
              <tr>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    S.No
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "serialNumber")}
                  >
                    {" "}
                    import_export{" "}
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "fullname")}
                  >
                    Name
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "fullname")}
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "admission_id")}
                  >
                    {" "}
                    AdmissionId
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "admission_id")}
                  >
                    import_export
                  </span>
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "phone_no")}
                  >
                    Phone Number
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "phone_no")}
                  >
                    import_export
                  </span>
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "mode_of_payment")}
                  >
                    Mode of <br /> payment
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "mode_of_payment")}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "payment_type")}
                    class={` align-middle material-icons ${
                      payment_type.length > 0 || isOpen.payment_type
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.payment_type === true && (
                    <div className="filterBoxs p-1" ref={filterPamentRef}>
                      <div className="row mt-4">
                        <div className="col-md-6">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Online"
                              value="1"
                              id="Online"
                              checked={payment_type.some((element) => {
                                if (element.name === "Online") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Online")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Online"
                            >
                              Online
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Offline"
                              value="0"
                              id="Offline"
                              checked={payment_type.some((element) => {
                                if (element.name === "Offline") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Offline")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Offline"
                            >
                              Offline
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("payment_type")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("payment_type")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "category_code")}
                  >
                    Category
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "category_code")}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "category_code")}
                    class={` align-middle material-icons ${
                      category_code.length > 0 || isOpen.category_code
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.category_code === true && (
                    <div className="filterBoxs p-1" ref={filterCategoryRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="UPSC"
                              value="UPSC"
                              id="UPSC"
                              checked={category_code.some((element) => {
                                if (element.name === "UPSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "UPSC", "category_code")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="UPSC"
                            >
                              UPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TNPSC"
                              value="TNPSC"
                              id="TNPSC"
                              checked={category_code.some((element) => {
                                if (element.name === "TNPSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "TNPSC",
                                  "category_code"
                                )
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TNPSC"
                            >
                              TNPSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="RRB"
                              value="RRB"
                              id="RRB"
                              checked={category_code.some((element) => {
                                if (element.name === "RRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "RRB", "category_code")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="RRB"
                            >
                              RRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TET"
                              value="TET"
                              id="TET"
                              checked={category_code.some((element) => {
                                if (element.name === "TET") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TET", "category_code")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TET"
                            >
                              TET
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TRB"
                              value="TRB"
                              id="TRB"
                              checked={category_code.some((element) => {
                                if (element.name === "TRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TRB", "category_code")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TRB"
                            >
                              TRB
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TNUSRB"
                              value="TNUSRB"
                              id="TNUSRB"
                              checked={category_code.some((element) => {
                                if (element.name === "TNUSRB") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "TNUSRB",
                                  "category_code"
                                )
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="TNUSRB"
                            >
                              TNUSRB
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="SSC"
                              value="SSC"
                              id="SSC"
                              checked={category_code.some((element) => {
                                if (element.name === "SSC") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "SSC", "category_code")
                              }
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="SSC"
                            >
                              SSC
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Banking"
                              value="Banking"
                              checked={category_code.some((element) => {
                                if (element.name === "Banking") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(
                                  e,
                                  "Banking",
                                  "category_code"
                                )
                              }
                              id="Banking"
                            />
                            <label
                              class="form-check-label "
                              for="defaultCheck1"
                              htmlFor="Banking"
                            >
                              Banking
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("category_code")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("category_code")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "course_name")}
                  >
                    Course
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "course_name")}
                  >
                    import_export
                  </span>
                  {/* <span
                      class={` align-middle material-icons  ${
                        course_name.length > 0 ? "active_icons" : ""
                      }`}
                      onClick={(e) => handleFilter(e, "course_name")}
                    >
                      filter_list
                    </span> */}
                  {/* {isOpen.course_name === true && (
                        <div className="filterBoxs p-1">
                        <div className="filterBoxText">
                        <div className="row ms-1">
                            <div className="col-lg-12 col-md-12">
                              <div class="input-group searchInputsss">
                                <input
                                  type="text"
                                  class="Inputs "
                                  id="SearchFilterInputs"
                                  name="SearchFilterInputs"
                                  placeholder="Search Here"
                                  // onChange={handleSearch}
                                  onKeyDown={handleFilterCourseSearch}
                                />
                                <span class="input-group-text" id="SearchInput">
                                  <span className="material-icons">search</span>
                                </span>
                              </div>
                            </div>
                          </div>
                          <hr/>
                          {dCourses.map((el) => (
                            <div className="row mt-2">
                              <div className="col-md-12">
                                <div class="form-check ms-3">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    name={el} // Use el.label to set the name and value
                                    value={el}
                                    id={el}
                                    checked={course_name.some((element) => {
                                      if (element.name === el) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, "course_name")
                                    }
                                  />
                                  <label
                                    class="form-check-label PinkText preWrap"
                                    for="defaultCheck1"
                                  >
                                    {el}
                                  </label>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
  
                        <hr />
                        <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("course_name")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("course_name")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )} */}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "phone_no")}
                  >
                    Section
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "section")}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "section")}
                    class={` align-middle material-icons ${
                      section.length > 0 || isOpen.section ? "active_icons" : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.section === true && (
                    <div className="filterBoxTwo p-1" ref={filterSectionRef}>
                      <div className="row ms-1">
                        <div className="col-lg-12 col-md-12">
                          <div class="input-group searchInputsss">
                            <input
                              type="text"
                              class="Inputs "
                              id="SearchFilterInputs"
                              name="SearchFilterInputs"
                              placeholder="Search Here"
                              // onChange={handleSearch}
                              onKeyDown={handleFilterSectionSearch}
                            />
                            <span class="input-group-text" id="SearchInput">
                              <span className="material-icons">search</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {dSection.length > 0 ? (
                        dSection.filter(
                          (item) => item && item.trim() !== ""
                        ).map((el) => (
                          <div className="row mt-2" key={el}>
                            <div className="col-md-12">
                              <div className="form-check ms-3">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={el}
                                  value={el}
                                  id={el}
                                  checked={section.some((element) => element.name === el)}
                                  onChange={(e) => handleCheckboxChange(e, "section")}
                                />
                                <label
                                  className="form-check-label PinkText preWrap"
                                  htmlFor={el}
                                >
                                  {el}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="row mt-2">
                          <div className="col-md-12 text-center">
                            <span className="text-muted">No records found</span>
                          </div>
                        </div>
                      )}

                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("section")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            // disabled={section.length === 0 ? true : false}
                            onClick={() => handleApplyFilter("section")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "type")}
                  >
                    Type
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "type")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "type")}
                    class={` align-middle material-icons ${
                      typeOn.length > 0 || isOpen.type ? "active_icons" : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.type === true && (
                    <div className="filterBoxTwo p-1" ref={filterTypeRef}>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="course"
                              value="0"
                              checked={typeOn.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "course")
                              }
                              id="course"
                            />
                            <label
                              class="form-check-label YellowText"
                              for="defaultCheck1"
                              htmlFor="course"
                            >
                              Course
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="TestBatch"
                              value="1"
                              checked={typeOn.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "TestBatch")
                              }
                              id="TestBatch"
                            />
                            <label
                              class="form-check-label GreenText"
                              for="defaultCheck1"
                              htmlFor="TestBatch"
                            >
                              Test Batch
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="SpecialClass"
                              value="3"
                              checked={typeOn.some((element) => {
                                if (element.id === "3") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "SpecialClass")
                              }
                              id="SpecialClass"
                            />
                            <label
                              class="form-check-label YellowText"
                              for="defaultCheck1"
                              htmlFor="SpecialClass"
                            >
                              Special Class
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Counselling"
                              value="2"
                              checked={typeOn.some((element) => {
                                if (element.id === "2") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Counselling")
                              }
                              id="Counselling"
                            />
                            <label
                              class="form-check-label RedText"
                              for="defaultCheck1"
                              htmlFor="Counselling"
                            >
                              Counselling
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="MockInterview"
                              value="5"
                              checked={typeOn.some((element) => {
                                if (element.id === "5") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "MockInterview")
                              }
                              id="MockInterview"
                            />
                            <label
                              class="form-check-label RedText"
                              for="defaultCheck1"
                              htmlFor="MockInterview"
                            >
                              Mock Interview
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="ModelExam"
                              value="4"
                              checked={typeOn.some((element) => {
                                if (element.id === "4") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "ModelExam")
                              }
                              id="ModelExam"
                            />
                            <label
                              class="form-check-label RedText"
                              for="defaultCheck1"
                              htmlFor="ModelExam"
                            >
                              Model Exam
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("type")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            // disabled={typeOn.length === 0 ? true : false}
                            onClick={() => handleApplyFilter("type")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "batch_name")}
                  >
                    Batch
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "batch_name")}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "batch_name")}
                    class={` align-middle material-icons ${
                      batch_name.length > 0 || isOpen.batch_name
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.batch_name === true && (
                    <div
                      className="filterBoxTwo p-1 d-flex flex-column"
                      style={{ maxHeight: "400px" }}
                      ref={filterBatchRef}
                    >
                      <div className="row ms-1">
                        <div className="col-lg-12 col-md-12">
                          <div className="input-group searchInputsss">
                            <input
                              type="text"
                              className="Inputs"
                              id="SearchFilterInputs"
                              name="SearchFilterInputs"
                              placeholder="Search Here"
                              // onChange={handleSearch}
                              onKeyDown={handleFilterCourseSearch}
                            />
                            <span className="input-group-text" id="SearchInput">
                              <span className="material-icons">search</span>
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Scrollable Section */}
                      <div
                        style={{
                          maxHeight: "250px",
                          overflowY: "auto",
                          paddingRight: "5px",
                        }}
                      >
                        {dCourses.map((el, index) => (
                          <div className="row mt-2" key={index}>
                            <div className="col-md-12">
                              <div className="form-check ms-3">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name={el}
                                  value={el}
                                  id={el}
                                  checked={batch_name.some(
                                    (element) => element.name === el
                                  )}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "batch_name")
                                  }
                                />
                                <label
                                  className="form-check-label PinkText preWrap"
                                  htmlFor={el}
                                >
                                  {el}
                                </label>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Footer Section - Buttons (Static) */}
                      <div
                        className="mt-3"
                        style={{
                          borderTop: "1px solid #ddd",
                          paddingTop: "10px",
                        }}
                      >
                        <div className="row">
                          <div className="col-md-4 col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("batch_name")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8 col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              // disabled={batch_name.length === 0}
                              onClick={() => handleApplyFilter("batch_name")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "location_name")}
                  >
                    Location
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "location_name")}
                  >
                    import_export
                  </span>
                  <span
                    onClick={(e) => handleFilter(e, "location_name")}
                    class={` align-middle material-icons ${
                      location_name.length > 0 || isOpen.location_name
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.location_name === true && (
                    <div className="filterBoxTwo p-1" ref={filterLocationRef}>
                      <div className="row ms-1">
                        <div className="col-lg-12 col-md-12">
                          <div class="input-group searchInputsss">
                            <input
                              type="text"
                              class="Inputs "
                              id="SearchFilterInputs"
                              name="SearchFilterInputs"
                              placeholder="Search Here"
                              // onChange={handleSearch}
                            />
                            <span class="input-group-text" id="SearchInput">
                              <span className="material-icons">search</span>
                            </span>
                          </div>
                        </div>
                      </div>
                      {dLocation.map((el) => (
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <div class="form-check ms-3">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                name={el.name} // Use el.label to set the name and value
                                value={el.id}
                                id={el.name}
                                checked={location_name.some((element) => {
                                  if (element.name === el.name) {
                                    return true;
                                  }
                                  return false;
                                })}
                                onChange={(e) =>
                                  handleCheckboxChange(e, "location_name")
                                }
                              />
                              <label
                                class="form-check-label PinkText preWrap"
                                for="defaultCheck1"
                                htmlFor={el.name}
                              >
                                {el.name}
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("location_name")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            // disabled={location_name.length === 0 ? true : false}
                            onClick={() => handleApplyFilter("location_name")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "paid_amount")}
                  >
                    Paid <br /> Amount
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "paid_amount")}
                  >
                    import_export
                  </span>{" "}
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "balance_amt")}
                  >
                    Balance <br /> Amount
                  </span>{" "}
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "balance_amt")}
                  >
                    import_export
                  </span>{" "}
                </th>

                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "appliedOn")}
                  >
                    Applied <br /> On
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "appliedOn")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "appliedOn")}
                    class={` align-middle material-icons ${
                      (appData &&
                        Object.entries(appData).some(
                          ([key, val]) =>
                            key !== "name" &&
                            val !== null &&
                            val !== undefined &&
                            val.toString().trim() !== ""
                        )) ||
                      isOpen.appliedOn
                        ? "active_icons"
                        : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.appliedOn === true && (
                    <div
                      className="filterBoxOne filter_mmm container p-1"
                      ref={filterAppliedRef}
                    >
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="FDate"
                              className="d-flex form-label"
                            >
                              From Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                              id="FDate"
                              type="date"
                              name="FDate"
                              value={appData.FDate}
                              className="FilterInputs"
                              onChange={handleAppliedOn}
                              placeholder="FDate"
                              autoComplete="FDate"
                              required
                            /> */}
                            <DatePickerSample
                              IconInput={"filterIocnBoxInput"}
                              class={"FilterInputs"}
                              name={"FDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.FDate}
                              txtAdMDob={fDatePickerRef}
                              // maxDate={new Date()}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-1">
                        <div className="col-md-12">
                          <div class="form-check p-1">
                            <label
                              htmlFor="TDate "
                              className="d-flex form-label"
                            >
                              To Date
                              <span
                                data-required="true"
                                aria-hidden="true"
                              ></span>
                            </label>
                            {/* <input
                              id="TDate"
                              type="date"
                              name="TDate"
                              value={appData.TDate}
                              className="FilterInputs"
                              placeholder="TDate"
                              onChange={handleAppliedOn}
                              autoComplete="TDate"
                              required
                            /> */}
                            <DatePickerSample
                              class={"FilterInputs"}
                              IconInput={"filterIocnBoxInput"}
                              name={"TDate"}
                              handleChange={handleChangeDate}
                              fieldInput={appData.TDate}
                              txtAdMDob={tDatePickerRef}
                              minDate={appData.FDate}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              id="Today"
                              value="Today"
                              checked={appData.Days === "Today"}
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Today"
                              htmlFor="Today"
                              style={{ fontWeight: "bold" }}
                            >
                              Today
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Yesterday"
                              checked={appData.Days === "Yesterday"}
                              id="Yesterday"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Yesterday"
                              style={{ fontWeight: "bold" }}
                              htmlFor="Yesterday"
                            >
                              Yesterday
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tweek"
                              checked={appData.Days === "Tweek"}
                              id="Tweek"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tweek"
                              htmlFor="Tweek"
                              style={{ fontWeight: "bold" }}
                            >
                              This week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Lweek"
                              checked={appData.Days === "Lweek"}
                              id="Lweek"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lweek"
                              htmlFor="Lweek"
                              style={{ fontWeight: "bold" }}
                            >
                              Last week
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              value="Tmonth"
                              checked={appData.Days === "Tmonth"}
                              id="Tmonth"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Tmonth"
                              htmlFor="Tmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              This month
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                          <div class="form-check">
                            <input
                              class="form-check-input"
                              type="radio"
                              name="Days"
                              checked={appData.Days === "Lmonth"}
                              value="Lmonth"
                              id="Lmonth"
                              onChange={handleAppliedOn}
                            />
                            <label
                              class="form-check-label d-flex"
                              for="Lmonth"
                              htmlFor="Lmonth"
                              style={{ fontWeight: "bold" }}
                            >
                              Last month
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("appliedOn")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            onClick={() => handleApplyFilter("appliedOn")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  <span
                    className="text_th"
                    onClick={(e) => handleSort(e, "status")}
                  >
                    Status
                  </span>
                  <span
                    class="material-icons align-middle"
                    onClick={(e) => handleSort(e, "status")}
                  >
                    import_export
                  </span>{" "}
                  <span
                    onClick={(e) => handleFilter(e, "status")}
                    className={`align-middle material-icons ${
                      status.length > 0 || isOpen.status ? "active_icons" : ""
                    }`}
                  >
                    filter_list
                  </span>
                  {isOpen.status === true && (
                    <div className="filterBox_bb p-1" ref={filterStatusRef}>
                      <div className="row mt-4">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="waitingForApproval"
                              value="0"
                              checked={status.some((element) => {
                                if (element.id === "0") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "waitingForApproval")
                              }
                              id="waitingForApproval"
                            />
                            <label
                              class="form-check-label YellowText"
                              for="waitingForApproval"
                            >
                              Waiting For Approval
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="approved"
                              value="1"
                              checked={status.some((element) => {
                                if (element.id === "1") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Approved")
                              }
                              id="Approved"
                            />
                            <label
                              class="form-check-label GreenText"
                              for="Approved"
                            >
                              Approved
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="onHold"
                              value="2"
                              checked={status.some((element) => {
                                if (element.id === "2") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "OnHold")
                              }
                              id="OnHold"
                            />
                            <label
                              class="form-check-label YellowText"
                              for="OnHold"
                            >
                              On Hold
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-12">
                          <div class="form-check ms-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              name="Rejected"
                              value="3"
                              checked={status.some((element) => {
                                if (element.id === "3") {
                                  return true;
                                }
                                return false;
                              })}
                              onChange={(e) =>
                                handleCheckboxChange(e, "Rejected")
                              }
                              id="Rejected"
                            />
                            <label
                              class="form-check-label RedText"
                              for="Rejected"
                            >
                              Rejected
                            </label>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <div className="col-md-4  col-4 col-sm-4">
                          <span
                            className="clearFilter ms-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClear("status")}
                          >
                            Clear
                          </span>
                        </div>
                        <div className="col-md-8  col-8 col-sm-8">
                          <button
                            className="FilterButton"
                            // disabled={status.length === 0 ? true : false}
                            onClick={() => handleApplyFilter("status")}
                          >
                            Apply Filter
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th id="th">
                  {" "}
                  <span className="text_th">Action</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                <>
                  {currentData.map((el, index) => (
                    <tr key={index}>
                      <td id="td">
                        {el.comment === 1 && el.status !== 1 && (
                          <div className="purchase_dot_chat"></div>
                        )}
                        <span>{el.serialNumber}</span>
                      </td>
                      <td id="td">{el.fullname}</td>
                      <td id="td">{el.admission_id}</td>
                      <td id="td">{el.phone_no}</td>
                      <td id="td">
                        {el.mode_of_payment === 1 ? "Online" : "Offline"}
                      </td>
                      <td id="td">{el.category_code}</td>
                      <td id="td">{el.course_name}</td>
                      <td id="td">{el.section ? el.section : "_"}</td>
                      {el.type === 0 && (
                        <td id="td">
                          <span>course</span>
                        </td>
                      )}
                      {el.type === 1 && (
                        <td id="td">
                          <span>Test Batch</span>
                        </td>
                      )}
                      {el.type === 2 && (
                        <td id="td">
                          <span>Counselling</span>
                        </td>
                      )}
                      {el.type === 3 && (
                        <td id="td">
                          <span>Special classes</span>
                        </td>
                      )}
                      {el.type === 4 && (
                        <td id="td">
                          <span>Model exam </span>
                        </td>
                      )}
                      {el.type === 5 && (
                        <td id="td">
                          <span>Mock Interview </span>
                        </td>
                      )}
                      <td id="td">{el.batch_name}</td>
                      <td id="td">{el.location_name}</td>
                      <td id="td">
                        ₹ {el.paid_amount !== null ? el.paid_amount : 0}
                      </td>
                      <td id="td">
                        ₹ {el.balance_amt !== null ? el.balance_amt : 0}
                      </td>
                      <td id="td">
                        {moment(el.appliedOn).format("YYYY-MM-DD")}
                      </td>
                      {el.status === 2 && (
                        <td id="td">
                          <span class="YellowText">OnHold</span>
                        </td>
                      )}
                      {el.status === 1 && (
                        <td id="td">
                          <span class="GreenText">Approved</span>
                        </td>
                      )}
                      {el.status === 3 && (
                        <td id="td">
                          <span class="RedText">Rejected</span>
                        </td>
                      )}
                      {el.status === 0 && (
                        <td id="td">
                          <span class="YellowText">Waiting For Approval</span>
                        </td>
                      )}
                      <td>
                        {" "}
                        <span
                          onClick={(e) =>
                            handleEdit(
                              el.user_id,
                              el.adm_pk,
                              moment(el.appliedOn).format("YYYY-MM-DD"),
                              el.type
                            )
                          }
                          class="material-icons text-danger"
                        >
                          exit_to_app
                        </span>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="100%" style={{ textAlign: "center" }}>
                    <div
                      className="col-md-12 text-center"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        // backgroundColor: "#e3e5e2",
                      }}
                    >
                      <div className="col-md-3"> </div>
                      <div className="col-md-6 r" role="alert">
                        We're sorry, but there are no results that match the
                        search and filter criteria you've applied. Please adjust
                        your filters or try a different search term to see if
                        you can find what you're looking for.
                      </div>
                      <div className="col-md-3"> </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 TableItemPerpage">
          <div className="pag w-100 dflexcenter mt-4">
            <span className="ipage">Items Per Page</span>
            <select
              name="pageCount"
              id="pageCount"
              defaultValue={rowsPerPage}
              onChange={handlePageCount}
              className="ms-2"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            <span className="pagenumber ms-2">
              {" "}
              {currentPage * rowsPerPage + 1 - rowsPerPage} -{" "}
              {/* {currentPage * rowsPerPage} of {updateListData.length} */}
              {updateListData.length < currentPage * rowsPerPage
                ? updateListData.length
                : currentPage * rowsPerPage}{" "}
              of {updateListData.length}
            </span>
            <button
              className="prev_button ms-2 me-2"
              onClick={(e) => handlePrev(currentPage - 1)}
              disabled={currentPage <= 1}
            >
              <span class="material-icons">chevron_left</span>
            </button>
            <button
              className="prev_button"
              onClick={() => handleNext(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              <span class="material-icons">chevron_right</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Listview;
